const PaneView = require('./paneview');

const TabsView = Backbone.View.extend({
	initialize: function (options) {
		// this.model = options.model;
		this.list = options.list;
		this.parentView = options.parentView;
		this.attr = options.attr;
		this.callType = options.callType;
		this.tabsTpl = JST.navTabsTpl;
		this.panesTpl = options.tabPanesTpl;
		if (options.hasSelect) {
			this.hasSelect = options.hasSelect;
		}
		this.render();
	},
	render: function () {
			var newAddressPane;
			this.$elTabs = this.$("ul[role=tablist]");
			this.$elPanes = this.$(".tab-content");
			if (this.collection.length > 0) {
			  _.forEach(this.collection.models, function (item, i) {
							var count = i + 1;
							// add tabs
							this.$elTabs.append(this.tabsTpl({
									"propName": "address" + i,
									"label": "Address " + count
							}));
							// add blank panes
							this.$elPanes.append(this.panesTpl({ "propName": "address" + i, "index": i }));
							// create PaneView within blank pane el
							item.view = new PaneView({
									model: item,
									el: $("#address" + i),
									"parentView": this,
									"renderList": this.list
							});
							item.view.render();
					}, this);
					// create new address tab
					this.$elTabs.append(this.tabsTpl({
							"propName": "address" + this.collection.length,
							"label": "Add New"
					}));
					// create new address pane
					this.$elPanes.append(this.panesTpl({ "propName": "address" + this.collection.length, "index": +this.collection.length }));
					newAddressPane = new PaneView({
							model: new phillips.LocationAddressViewModel(),
							el: $("#address" + this.collection.length),
							"parentView": this,
							"renderList": this.list,
							"isNew": true
					});
			} else {
					this.$elTabs.append(this.tabsTpl({
							"propName": "address" + 0,
							"label": "Add New"
					}));
					this.$elPanes.append(this.panesTpl({ "propName": "address" + 0, "index": 0 }));
					newAddressPane = new PaneView({
							model: new phillips.LocationAddressViewModel(),
							el: $("#address" + this.collection.length),
							"parentView": this,
							"renderList": this.list,
							"isNew": true
					});
			}
			newAddressPane.render();
			this.$elTabs.children("li").eq(0).addClass("active");
			this.$elPanes.children().eq(0).addClass("active");
	},
	updateAdd: function (e) {
			var formObj = {},
				tabModel = this.collection.at($(e.target).data("id")).get("address");
			$(e.target).siblings("input").serializeArray().map(function (obj) {
					formObj[obj.name] = obj.value;
					//if (obj.name === "countryID") {
					//  formObj["countryDesc"] = $(e.target).find("select#" + obj.name).children("option[value=" + obj.value +"]").text();
					//} else if (obj.name === "stateID") {
					//  formObj["stateDesc"] = $(e.target).find("select#" + obj.name).children("option[value=" + obj.value +"]").text();
					//}
			});
			tabModel.set(formObj);
	},
	addNew: function (newModel) {
			console.log(newModel);
			this.collection.add(newModel);
			console.log(this.collection);
	},
	removePane: function (pane) {
			this.$el.find("li\[data-tab=\'" + pane.$el.attr("id") + "\'\]").removeData().unbind();
			this.$el.find("li\[data-tab=\'" + pane.$el.attr("id") + "\'\]").remove();
			pane.destroy();
			this.$elTabs.children("li").eq(0).addClass("active");
			this.$elPanes.children().eq(0).addClass("active");
	}
});

export default TabsView;
